import type { CSSProperties, ReactNode } from 'react';
import {
  CM_PERF_SECURITY_STATUSES,
  CM_PERF_SECURITY_TYPES,
  fmtCmPerfSecurityExpiry,
  isCmBankGuaranteeType,
} from '@lib/cmServices';

function Field({
  label,
  children,
  style,
}: {
  label: string;
  children: ReactNode;
  style?: CSSProperties;
}) {
  return (
    <div className="fg2" style={style}>
      <label>{label}</label>
      {children}
    </div>
  );
}

export default function CmPerfSecurityFields({
  form,
  set,
  formField,
}: {
  form: Record<string, unknown>;
  set: (key: string, val: unknown) => void;
  formField: (form: Record<string, unknown>, key: string) => string;
}) {
  const perfType = formField(form, 'perfSecurityType');
  const isBg = isCmBankGuaranteeType(perfType);
  const expiryHint = fmtCmPerfSecurityExpiry(formField(form, 'perfSecurityValidityDate'));

  return (
    <>
      <Field label="Performance Security Type">
        <select
          value={perfType}
          onChange={(e) => {
            const next = e.target.value;
            set('perfSecurityType', next);
            if (!isCmBankGuaranteeType(next)) {
              set('perfSecurityRemarks', '');
              set('perfSecurityValidityDate', '');
              set('perfSecurityIssueDate', '');
            }
          }}
        >
          <option value="">—</option>
          {CM_PERF_SECURITY_TYPES.map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>
      </Field>
      <Field label="Performance Security Status">
        <select
          value={formField(form, 'perfSecurity')}
          onChange={(e) => set('perfSecurity', e.target.value)}
        >
          <option value="">—</option>
          {CM_PERF_SECURITY_STATUSES.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </Field>
      {isBg && (
        <>
          <Field label="Issue Date">
            <input
              type="date"
              value={formField(form, 'perfSecurityIssueDate')}
              onChange={(e) => set('perfSecurityIssueDate', e.target.value)}
            />
          </Field>
          <Field label="Validity Date">
            <input
              type="date"
              value={formField(form, 'perfSecurityValidityDate')}
              onChange={(e) => set('perfSecurityValidityDate', e.target.value)}
            />
            {expiryHint && (
              <span className={`cm-bg-expiry-hint cm-bg-expiry-hint--${expiryHint === 'Expired' ? 'expired' : 'expiring'}`}>
                {expiryHint}
              </span>
            )}
          </Field>
          <Field label="Remarks" style={{ gridColumn: '1 / -1' }}>
            <textarea
              value={formField(form, 'perfSecurityRemarks') || ''}
              onChange={(e) => set('perfSecurityRemarks', e.target.value)}
              rows={2}
              placeholder="Bank guarantee remarks"
            />
          </Field>
        </>
      )}
    </>
  );
}
